<div class="container" *ngIf="!loading">
    <div class="row">
        <div class="col-sm-12">
            <h4> Aktionen positionieren</h4>
        </div>
    </div>
    <div class="row marginTop2Rem marginBottom2Rem">
        <div class="col-sm-12">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-content>

                    <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
                        <div class="example-box" *ngFor="let element of positions;let i = index" cdkDrag>
                            <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                            <span style="width: 90%;display: flex;justify-content: space-between;align-items: center;">
                                <span style="width: 5;">
                                    {{i+1}}
                                </span>
                                <span style="width: 75%;">
                                    {{element.title}}
                                </span>

                                <span style="width: 10%;">
                                    {{element?.created | date : 'dd.MM.YYYY'}}
                                </span>
                                <mat-chip-set style="width: 10%;">
                                    <mat-chip class="primaryChip" selected>{{element.state |
                                        translateState}}</mat-chip>
                                </mat-chip-set>
                            </span>
                            <button mat-icon-button style="margin: 0 auto !important;" (click)="moveOnePositionUP(i)">
                                <mat-icon> keyboard_arrow_up </mat-icon>
                            </button>

                            <button mat-icon-button style="margin: 0 auto !important;" (click)="moveOnePositionDown(i)">
                                <mat-icon>keyboard_arrow_down</mat-icon>
                            </button>

                            <button mat-icon-button style="margin: 0 auto !important;" (click)="moveOnePositionTop(i)">
                                <mat-icon class="rotate90Deg">first_page</mat-icon>
                            </button>
                            <button mat-icon-button style="margin: 0 auto !important;" (click)="moveOnePositionLast(i)">
                                <mat-icon class="rotate90Deg">last_page</mat-icon>
                            </button>
                        </div>
                    </div>

                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="saveChanges()">Änderungen speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>

<div class="container" *ngIf="loading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>